module.exports = __webpack_public_path__ + "static/img/06.c610228.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour6/06.jpg
// module id = 7L66
// module chunks = 0